$(document).ready(function () {
  // General Message
  $('.generalmessage').prependTo('header');
});

$(window).load(function () {
  $('.viewcart').clone().appendTo('.cart-mobile');
  $(".container-signup .emailSubmitButton").text("Sign Up");
  $(".inputFieldTextbox").attr("placeholder", "Email Address:");
  $(".all-events-btn").addClass("button moreButton");


  // setTimeout(() => {
  if ($("#body").hasClass("siteInfoBannerWidgetDateIsPast")) {
    setTimeout(() => {
    $('#siteInfoBannerWidget').clone().appendTo('.mobile-countdown');
    $("#siteInfoBannerWidget #eventDates").addClass("hidingComponent")
    }, 800)
  } else {
    $(".countdownDays").children('').text('days until ')
    $(".countdownDays").prepend('Only ')
    $('#siteInfoBannerWidget').clone().appendTo('.mobile-countdown');
  }
// }, 2000)
});


